import React, { useState, useEffect, useMemo } from "react";
import { useIntl } from "react-intl";
import { Box } from "@chakra-ui/react";
import { useSettings } from "utils/settingsContext";
import { Select } from "chakra-react-select";
import { localizedRegionsFactory } from "utils/regions";

const CountrySelector = ({ onChange, size = "md" }) => {
  const { appSettings } = useSettings();

  const [selectedCountry, setSelectedCountry] = useState(null);
  const [supportedCountries, setSupportedCountries] = useState([]);

  const { formatMessage } = useIntl();

  const supportedBankAccountCountries = useMemo(
    () => appSettings.supported_bank_account_countries,
    [appSettings.supported_bank_account_countries]
  );

  const regions = useMemo(() => localizedRegionsFactory(formatMessage), [formatMessage]);

  useEffect(() => {
    if (regions && supportedBankAccountCountries) {
      let usaOption = null; // let's grab hold of the US option while we running through the options
      let options = Object.keys(supportedBankAccountCountries).map((supportedCountryISO) => {
        const found = regions.find((region) => region.ISO === supportedCountryISO);
        if (found?.ISO === "US") usaOption = found;
        return found;

      });

      if (!usaOption) {
        // unlikely this will happen, but as we want to set US by default, we need to make sure US is available
        console.error("missing US option in supported bank account countries, this really shouldn't be the case"); // unlikely, but let's make sure
        usaOption = regions.find((region) => region.ISO === "US");
        options.push(usaOption);
      }

      options = options.map((supportedCountry) => ({
        label: supportedCountry.Name,
        value: supportedCountry.ISO,
        currency: supportedCountry.PrimaryCurrency,
      })).sort((a, b) => a.label?.localeCompare(b.label)); // sort alphabetically by label

      setSupportedCountries(options);
    }
  }, [regions, supportedBankAccountCountries]);

  const handleChange = (countryOption) => {
    setSelectedCountry(countryOption);
    onChange && onChange(countryOption);
  };

  return (
    <Box
      onClick={(e) => {
        e.stopPropagation();
      }}
      minW="160px"
      data-testid="country-selector"
    >
      <Select
        role="country-selector" // eslint-disable-line jsx-a11y/aria-role
        value={selectedCountry}
        options={supportedCountries}
        onChange={handleChange}
        size={size}
        placeholder={formatMessage({
          defaultMessage: "Select...",
          description: "select placeholder",
        })}
      />
    </Box>
  );
};

export default CountrySelector;
